import React from 'react';
import PropertyTaxView from './PropertyTaxView';

const createPropertyTaxViewAdapter = (soid) => {
  return () => <PropertyTaxView serviceOfferingId={soid} />;
};

export default createPropertyTaxViewAdapter;
